import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoadingController, MenuController } from '@ionic/angular';
import { StoreRequestDto, StoreService } from 'src/generated_client';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  loading: HTMLIonLoadingElement;

  loginForm: FormGroup = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
  })

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private loadingController: LoadingController,
    private storeService: StoreService,
    public alertService: AlertService,
    private menu: MenuController
  ) {
    this.menu.enable(false, 'custom');
  }

  request = {} as StoreRequestDto;

  ngOnInit(): void {
    this.tryAutoLogin();
  }

  tryAutoLogin() {
    let token = localStorage.getItem("storeToken");
    if (token) {
      this.router.navigate(['/orders-summary']);
    }
  }

async  login(form: any) {
    this.loading = await this.loadingController.create({
      message: "Cargando...",
  });
  await this.loading.present();
    this.request = {
      dsEmail: form.username,
      dsPassword: form.password
    }
    this.storeService.apiStoreStoreLoginPost(this.request).subscribe(
      loginResponse => {
        this.authService.loginStore(loginResponse);
        this.router.navigateByUrl('orders-summary');
        this.loading.dismiss()
      },
      err => {
        this.alertService.presentAlertOneBtn("Error al iniciar sesión", "Usuario y/o contraseña incorrectos", "Aceptar")
        this.loginForm.reset();
        this.loading.dismiss()
      }
    );
  }

}